import { useEffect, useState } from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import HeroCarousel from "../components/site/HeroCarousel";
import Seo from "../components/site/Seo";
import { SectionDivider } from "../components/site/SectionDivider";
import ChatbotMascot from "../components/site/ChatbotMascot";
import TestimonialsSection from "../components/site/Testimonials";
import InternshipForm from "../components/site/InternshipForm";
import {
  AboutSection,
  DomainSection,
  AISolutionsSection,
  UnidafSection,
  ServicesSection,
  ClientsSection,
  ContactSection,
} from "../components/site/Sections";
import {
  ProjectsSection,
  LeadershipSection,
  BlogsSection,
  CareersSection,
} from "../components/site/ContentSections";
import { api } from "../lib/api";

export default function Home() {
  const [data, setData] = useState({
    slides: [],
    projects: [],
    leaders: [],
    blogs: [],
    careers: [],
  });

  useEffect(() => {
    const load = async () => {
      try {
        const [slides, projects, leaders, blogs, careers] = await Promise.all([
          api.get("/hero-slides"),
          api.get("/projects"),
          api.get("/leaders"),
          api.get("/blogs"),
          api.get("/careers"),
        ]);
        setData({
          slides: slides.data,
          projects: projects.data,
          leaders: leaders.data,
          blogs: blogs.data,
          careers: careers.data,
        });
      } catch (e) {
        // backend not ready - render empty layout
      }
    };
    load();
  }, []);

  return (
    <div data-testid="home-page" className="bg-white">
      <Seo path="/" />
      <a
        href="#main-content"
        data-testid="skip-to-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-[#FF8C00] focus:text-white focus:px-4 focus:py-2 focus:rounded-md focus:font-semibold focus:text-sm"
      >
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content" tabIndex="-1">
        <HeroCarousel slides={data.slides} />
        <SectionDivider variant="neural" />
        <AboutSection />
        <SectionDivider variant="circuit" />
        <DomainSection />
        <SectionDivider variant="datastream" />
        <AISolutionsSection />
        <SectionDivider variant="neural" flip />
        <UnidafSection />
        <SectionDivider variant="circuit" />
        <ServicesSection />
        <SectionDivider variant="datastream" />
        <ProjectsSection projects={data.projects} />
        <SectionDivider variant="neural" />
        <LeadershipSection leaders={data.leaders} />
        <SectionDivider variant="circuit" />
        <ClientsSection />
        <SectionDivider variant="neural" flip />
        <TestimonialsSection />
        <SectionDivider variant="datastream" />
        <CareersSection careers={data.careers} />
        <SectionDivider variant="circuit" />
        <InternshipForm />
        <SectionDivider variant="neural" flip />
        <BlogsSection blogs={data.blogs} />
        <SectionDivider variant="circuit" />
        <ContactSection />
      </main>
      <Footer />
      <ChatbotMascot />
    </div>
  );
}
